import { render, staticRenderFns } from "./GvntTable.vue?vue&type=template&id=73fde281&scoped=true&"
import script from "./GvntTable.vue?vue&type=script&lang=js&"
export * from "./GvntTable.vue?vue&type=script&lang=js&"
import style0 from "./GvntTable.vue?vue&type=style&index=0&id=73fde281&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fde281",
  null
  
)

export default component.exports